import MainPressureVessel from "../PressureVessel";
import DataTabs from "../PressureVessel/PressureVesselData";
import AssetManagementTab from "./AssetManagementTab";
// import DCS from "./DCS";
import DCSTab from "./DCSTab";
// import DownloadPage from "./DownloadPage";
import EstimationTab from "./EstimationTab";
import MCS3 from "./MCS3";
// import MCSPage from "./MCSTab";
import PCS from "./PCSTab";
// import PMSTabs from "./PMSTab";
import PMSTab2 from "./PMSTab2";
import PVModeling from "./PV3";

export const equipMainTabs = [
  // "File",
  // "Data",
  // "Calc.",
  "Est.",
  "DCS",
  "MCS",
  "PCS",
  // "AMS",
  "PMS",
  // "PV Modeling",
  "PV",
  // "Software",
];

export const CommonTabs = (reRender, project) => [
  {
    title: "EstimationTab",
    panel: <EstimationTab reRender={reRender} />,
    // panelProps: { backgroundColor: "transparent", padding: 3 },
  },
  {
    title: "DCSPage",
    panel: <DCSTab reRender={reRender} />,
  },
  {
    title: "MCSPage",
    // panel: <MCSPage />
    panel: <MCS3 project={project} />,
  },
  {
    title: "PCS",
    panel: <PCS />,
  },
  // {
  //     title: "AssetManagementTab",
  //     panel: <AssetManagementTab />
  // },
  {
    title: "PMSTab",
    panel: <PMSTab2 />,
  },

  {
    title: "PV Modeling",
    panel: <PVModeling />,
  },

  //old
  // {
  //   title: "PV",
  //   panel: <DataTabs />,
  // },

  // {
  //     title: "DownloadPage",
  //     panel: <DownloadPage /> MainPressureVessel
  // },
];
